import WebFont from 'webfontloader';

// These fonts are not a part of Google fonts, and will return a 403 error if
// they are requested by the webfont loader.
export const SYSTEM_FONT_NAMES = [
    'Arial',
    'Arial Black',
    'Tahoma',
    'Trebuchet MS',
    'Verdana',
    'Courier',
    'Courier New',
    'Georgia',
    'Times',
    'Times New Roman',
] as const;

export function fetchFormFont(fontName: string) {
    // @ts-expect-error
    if (!SYSTEM_FONT_NAMES.includes(fontName)) {
        WebFont.load({
            google: {
                // Load the font and all potential weights (if any)
                families: [`${fontName}:300,400,500,600,700,800`],
            },
        });
    }
}
